import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { PATHS } from '../../routes/paths';

/** Signs the patient in and returns them to where they were heading (e.g. a booking). */
export default function useAuthRedirect() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || PATHS.home;
  return {
    from,
    complete: (session, remember) => {
      signIn(session, remember);
      navigate(from, { replace: true, state: location.state?.fromState });
    },
  };
}
